module.exports = __webpack_public_path__ + "static/media/howItWorksStartupIcon04.2ec19d37.svg";